import dynamic from 'next/dynamic';

export const ArrowIcon = dynamic(() => import('./Icon/ArrowIcon'));
// 排行榜icon
export const Champion = dynamic(() => import('./Icon/Champion'));
export const RunnerUp = dynamic(() => import('./Icon/RunnerUp'));
export const SecondRunnerUp = dynamic(() => import('./Icon/SecondRunnerUp'));
export const ChampionLeft = dynamic(() => import('./Icon/ChampionLeft'));
export const ChampionRight = dynamic(() => import('./Icon/ChampionRight'));
// how it work icon
export const WorkIcon1 = dynamic(() => import('./Icon/WorkIcon1'));
export const WorkIcon2 = dynamic(() => import('./Icon/WorkIcon2'));
export const WorkIcon3 = dynamic(() => import('./Icon/WorkIcon3'));
export const WorkIcon4 = dynamic(() => import('./Icon/WorkIcon4'));
export const WorkIcon5 = dynamic(() => import('./Icon/WorkIcon5'));
export const WorkArrowIcon = dynamic(() => import('./Icon/WorkArrowIcon'));
export const WorkArrowIcon2 = dynamic(() => import('./Icon/WorkArrowIcon2'));
// 优惠券icon
export const CouponIcon = dynamic(() => import('./Icon/CouponIcon'));
export const IntegralIcon = dynamic(() => import('./Icon/IntegralIcon'));
export const GiftIcon = dynamic(() => import('./Icon/GiftIcon'));
export const IntArrowIcon = dynamic(() => import('./Icon/IntArrowIcon'));
export const QuestionIcon = dynamic(() => import('./Icon/QuestionIcon'));
export const QuestionIcon2 = dynamic(() => import('./Icon/QuestionIcon2'));
export const CopyIcon = dynamic(() => import('./Icon/CopyIcon'));
// 2023 会员权益展示icon
export const ShopIcon = dynamic(() => import('./Icon/ShopIcon'));
export const MedalIcon = dynamic(() => import('./Icon/MedalIcon'));
export const CardIcon = dynamic(() => import('./Icon/CardIcon'));
export const PhoneIcon = dynamic(() => import('./Icon/PhoneIcon'));
export const WrenchIcon = dynamic(() => import('./Icon/WrenchIcon'));
export const GiftIcon2 = dynamic(() => import('./Icon/GiftIcon2'));
export const ShareIcon = dynamic(() => import('./Icon/ShareIcon'));
export const ShakeHands = dynamic(() => import('./Icon/ShakeHands'));
export const Coupon2 = dynamic(() => import('./Icon/Coupon2'));
// 订阅弹窗icon
export const GiftIcon3 = dynamic(() => import('./Icon/GiftIcon3'));
export const EmailIcon = dynamic(() => import('./Icon/EmailIcon'));
export const SubSuccessIcon = dynamic(() => import('./Icon/SubSuccessIcon'));
// 分享弹窗icon
export const FaceBookIcon = dynamic(() => import('./Icon/FaceBookIcon'));
export const FaceBookIconNew = dynamic(() => import('./Icon/FaceBookIconNew'));
export const TwitterIcon = dynamic(() => import('./Icon/TwitterIcon'));
export const TwitterIconNew = dynamic(() => import('./Icon/TwitterIconNew'));
export const WsAppIcon = dynamic(() => import('./Icon/WsAppIcon'));
// 2023-11-22
export const EcoCredits = dynamic(() => import('./Icon/EcoCredits'));
export const Cash = dynamic(() => import('./Icon/Cash'));
export const GrandPrizes = dynamic(() => import('./Icon/GrandPrizes'));
export const GiftCard = dynamic(() => import('./Icon/GiftCard'));
export const EcoCreditsBlue = dynamic(() => import('./Icon/EcoCreditsBlue'));
export const GrandPrizesBlue = dynamic(() => import('./Icon/GrandPrizesBlue'));
export const Coupon = dynamic(() => import('./Icon/Coupon'));
// how it work icon
export const AmbassadorWorkIcon1 = dynamic(() => import('./Icon/AmbassadorWorkIcon1'));
export const AmbassadorWorkIcon2 = dynamic(() => import('./Icon/AmbassadorWorkIcon2'));
export const AmbassadorWorkIcon3 = dynamic(() => import('./Icon/AmbassadorWorkIcon3'));
export const AmbassadorWorkIcon4 = dynamic(() => import('./Icon/AmbassadorWorkIcon4'));
